"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
// import * as ReactDOMServer from 'ReactDOMServer';
var BannerProps_1 = require("./BannerProps");
var styles = require("./Banner.css");
var icons = require("./../../../styles/att-icons.css");
var utils_1 = require("../../../utils");
var Modal_1 = require("../Modal");
var ModalProps_1 = require("../Modal/ModalProps");
var LabelProps_1 = require("../Label/LabelProps");
var Label_1 = require("../Label");
var Banner = /** @class */ (function (_super) {
    __extends(Banner, _super);
    function Banner(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            modalDisplayed: false,
        };
        _this.openModal = _this.openModal.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        return _this;
    }
    Banner.prototype.openModal = function (e) {
        this.setState({ modalDisplayed: true });
    };
    Banner.prototype.closeModal = function () {
        this.setState({ modalDisplayed: false });
    };
    Banner.prototype.render = function () {
        var icon = this.props.data && BannerProps_1.iconMap.get(this.props.data.icontype);
        var showIcon = icon || this.props.data.iconURL;
        var classes = [this.props.options && this.props.options.className ? this.props.options.className : '',
            styles.bannerContainer, this.props.data.isTFNBanner ? styles.tfnBanner : ''];
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: { backgroundColor: this.props.data.bgColor, color: this.props.data.fontColor }, className: classes.join(' ') },
                React.createElement("div", { className: styles.bannerContainerHolder },
                    this.props.data && this.props.data.iconURL ?
                        React.createElement("img", { className: [styles.iconImage, styles.iconStyle].join(' '), src: this.props.data.iconURL })
                        : icon ? React.createElement("i", { className: [icons.attIcon, icon, styles.iconStyle].join(' ') }) : '',
                    React.createElement("div", { className: [styles.enableView, showIcon ? styles.mt05 : ''].join(' ') },
                        React.createElement("span", { tabIndex: 0, dangerouslySetInnerHTML: { __html: this.props.data.desktopText } }),
                        React.createElement("a", { onClick: this.openModal, className: styles.seeOfferLink, tabIndex: 0, href: "javascript:void(0)", rel: "noopener" },
                            React.createElement("span", { dangerouslySetInnerHTML: { __html: this.props.data.modalLinkLabel } }))),
                    React.createElement("div", { className: [styles.enableView, showIcon ? styles.mt05 : ''].join(' ') },
                        React.createElement("span", { tabIndex: 0, dangerouslySetInnerHTML: { __html: this.props.data.mobileText } }),
                        React.createElement("a", { onClick: this.openModal, className: styles.seeOfferLink, tabIndex: 0, href: "javascript:void(0)", rel: "noopener" },
                            React.createElement("span", { dangerouslySetInnerHTML: { __html: this.props.data.modalLinkLabel } }))))),
            this.props.data.modalData &&
                React.createElement(Modal_1.default, { testId: utils_1.default(this.props.testId, 'Modal', 'See Detail'), options: {
                        center: true,
                        show: this.state.modalDisplayed,
                        showClose: true,
                        size: ModalProps_1.ModalSizes.MEDIUM,
                        tabIndex: 0,
                    }, events: { onClose: this.closeModal } },
                    React.createElement("div", { className: styles.legalContainer },
                        React.createElement(Label_1.default, { data: { text: this.props.data.modalHeading }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING24, className: styles.legalHeading } }),
                        React.createElement("p", { dangerouslySetInnerHTML: {
                                __html: this.props.data.modalData,
                            } })))));
    };
    return Banner;
}(React.Component));
exports.default = Banner;
//# sourceMappingURL=Banner.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Banner/Banner.js
// module id = 1091
// module chunks = 8